import React from 'react';
import { Link } from 'react-router-dom';

import FormError from 'components/FormError.js';
import { prettyKey } from '../../helpers/formatters';
import { viewSubUrlFromCarrier } from '../../helpers/subs';
import { capitalize } from '../../helpers/strings';

const Credit = ({
  credit,
  onDelete,
  onCancel,
  error,
  success,
  isAdmin,
  subId,
  sub,
  carrier,
}) => {
  const linkToSub = viewSubUrlFromCarrier(subId, carrier);

  return (
    <div>
      <h1>Credit Details</h1>
      <p className="links">
        <Link className="mb-4" to={`/users/${credit.user_profile}/credits`}>
          &larr; Back to User Credits
        </Link>
      </p>
      <table className="table">
        <tbody>
          {[
            'id',
            'description',
            'category',
            'credit_type',
            'credit_owed',
            'credit_applied',
            'monthly',
            'ref_code',
            'referral',
            'to_date',
            'from_date',
            'date_created',
          ].map((attr) => (
            <tr key={attr}>
              <td>
                <strong>{prettyKey(attr)}</strong>
              </td>
              <td>
                {typeof credit[attr] !== 'undefined' &&
                  credit[attr] !== null &&
                  credit[attr].toString()}
              </td>
            </tr>
          ))}
          {credit.credit_purchase ? (
            <tr>
              <td>
                <strong>Credit Purchase</strong>
              </td>
              <td>
                <Link to={`/purchases/${credit.credit_purchase}/view`}>
                  {credit.credit_purchase}
                </Link>
              </td>
            </tr>
          ) : null}
          <tr>
            <td>
              <strong>Carrier</strong>
            </td>
            <td>{capitalize(carrier)}</td>
          </tr>
          <tr>
            <td>
              <strong>Subscription ID</strong>
            </td>
            <td>
              <Link to={linkToSub}>{subId}</Link>
            </td>
          </tr>
          <tr>
            <td>
              <strong>MDN</strong>
            </td>
            <td>{sub && sub.mdn}</td>
          </tr>
          <tr>
            <td>
              <strong>User Profile</strong>
            </td>
            <td>
              <Link to={`/users/${credit.user_profile}/view`}>
                {credit.user_profile}
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
      {error && <FormError error={error} />}
      {success && <div className="mar-t text-success">{success}</div>}
      {isAdmin && (
        <div className="mar-t">
          <button className="btn btn-warning mar-r" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onDelete}>
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default Credit;
